import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { hrRecordsApi } from "../../Services/hrRecordsApi";
import { formatDateOnlyIST, formatDateTimeIST, truthyLabel } from "../hrRecordsHelpers";
import "../../Views/ApprovedPrView.css";
import "../../Views/voyageView.css";
import "../hrRecords.css";

function TrainingMasterViewPage({ isSidebarExpanded }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [master, setMaster] = useState(null);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        const response = await hrRecordsApi.getTrainingMaster(id);
        if (mounted) {
          setMaster(response);
        }
      } catch (error) {
        console.error("Failed to fetch training master:", error);
      }
    };

    run();

    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <div
      className={`invoice-request-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="invoice-request-header-content">
        <div className="invoice-request-heading-content-left-side">
          <Tooltip title="Back" arrow>
            <IoMdArrowBack
              className="back-company"
              onClick={() => navigate("/training/catalouge")}
            />
          </Tooltip>
          Training Master Details
        </div>
      </div>

      <div className="data-form-body-voyage">
        {!master ? (
          <div className="loader-container">
            <div className="loader"></div>
            <div>Loading...</div>
          </div>
        ) : (
          <>
            <div className="project-detailss">
              <div className="project-detail-arround">
                <div className="project-details-left-side">
                  {[
                    ["Training Code", master.training_code],
                    ["Training Name", master.training_name],
                    ["Training Category", master.training_category],
                    ["Standard Body", master.standard_body],
                    ["Reference No.", master.standard_ref_no],
                    ["Section No.", master.standard_section_no],
                    ["Standard Description", master.standard_description],
                    [
                      "Repeat Policy",
                      master.repeat_every
                        ? `${master.repeat_every} ${master.repeat_unit || ""}`
                        : "N/A",
                    ],
                    ["Grace Days", master.grace_days],
                    ["Reminder Days Before", master.reminder_days_before],
                    ["Mandatory", truthyLabel(master.is_mandatory)],
                    ["Active", truthyLabel(master.is_active)],
                    ["Default Duration Hours", master.default_duration_hours],
                    ["Description", master.description],
                    ["Created At", formatDateTimeIST(master.created_at)],
                    ["Updated At", formatDateTimeIST(master.updated_at)],
                  ].map(([label, value]) => (
                    <div className="project-detail" key={label}>
                      <div className="detail-header">{label}:</div>
                      <div className="detail-part-voyage">{value || "N/A"}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <br />

            <div className="hr-records-section">
              <div className="hr-records-section-title">Recent Sessions</div>
              {master.recent_sessions?.length ? (
                <div className="data-list-table">
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>SESSION CODE</th>
                        <th>START DATE</th>
                        <th>END DATE</th>
                        <th>STATUS</th>
                        <th>TRAINER</th>
                        <th>PARTICIPANTS</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {master.recent_sessions.map((session) => (
                        <tr key={session.id} className="hoverable-row">
                          <td>{session.session_code || "NA"}</td>
                          <td>{formatDateOnlyIST(session.start_date)}</td>
                          <td>{formatDateOnlyIST(session.end_date)}</td>
                          <td>{session.session_status || "NA"}</td>
                          <td>{session.trainer_name || "NA"}</td>
                          <td>{session.participant_count || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="hr-records-empty">No sessions recorded yet.</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TrainingMasterViewPage;
